import { render, staticRenderFns } from "./SMSSender.vue?vue&type=template&id=4716ff41&scoped=true"
import script from "./SMSSender.vue?vue&type=script&lang=js"
export * from "./SMSSender.vue?vue&type=script&lang=js"
import style0 from "./SMSSender.vue?vue&type=style&index=0&id=4716ff41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4716ff41",
  null
  
)

export default component.exports